import { flexRender } from "@tanstack/react-table";
import { Card, Separator, Text, XStack, YStack } from "tamagui";
import { Fragment } from "react";
import { Fragment as Fragment2, jsx, jsxs } from "react/jsx-runtime";
const XPDataTableList = props => {
  const {
    getHeaderGroups,
    getRowModel
  } = props.table;
  const header = getHeaderGroups()[0]?.headers;
  return /* @__PURE__ */jsx(YStack, {
    children: getRowModel().rows.map(row => /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsxs(Card, {
        elevate: true,
        size: "$4",
        bordered: true,
        transition: "bouncy",
        scale: 0.96,
        ...(props.cardProps || {}),
        children: [/* @__PURE__ */jsx(Card.Header, {
          padded: true,
          children: /* @__PURE__ */jsx(YStack, {
            ...(props.rowContentProps || {}),
            children: row.getVisibleCells().map((cell, index) => {
              const headerEle = flexRender(header?.[index]?.column.columnDef.header, header?.[index]?.getContext());
              return /* @__PURE__ */jsxs(YStack, {
                py: "$1",
                children: [headerEle, /* @__PURE__ */jsx(Text, {
                  children: flexRender(cell.column.columnDef.cell, cell.getContext())
                })]
              }, cell.id);
            })
          })
        }), row.getIsExpanded() && props.renderSubComponent ? /* @__PURE__ */jsxs(Fragment2, {
          children: [/* @__PURE__ */jsx(Separator, {}), /* @__PURE__ */jsx(Card.Footer, {
            padded: true,
            children: /* @__PURE__ */jsx(XStack, {
              width: "100%",
              children: props.renderSubComponent(row)
            })
          })]
        }) : null]
      }, row.id), /* @__PURE__ */jsx(YStack, {
        height: "$2"
      }), " "]
    }, row.id))
  });
};
export { XPDataTableList };
//# sourceMappingURL=XPDataTableList.mjs.map
